import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [currentId, setCurrentId] = useState(() => localStorage.getItem("cinnabit_project") || null);
  const [loading, setLoading] = useState(false);

  const fetchProjects = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data);
      if (data.length > 0) {
        const stored = localStorage.getItem("cinnabit_project");
        const exists = data.find((p) => p.id === stored);
        if (!exists) {
          setCurrentId(data[0].id);
          localStorage.setItem("cinnabit_project", data[0].id);
        } else if (!currentId) {
          setCurrentId(stored);
        }
      } else {
        setCurrentId(null);
      }
    } finally {
      setLoading(false);
    }
  }, [user, currentId]);

  useEffect(() => {
    if (user) fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const selectProject = (id) => {
    setCurrentId(id);
    localStorage.setItem("cinnabit_project", id);
  };

  const current = projects.find((p) => p.id === currentId) || null;

  return (
    <ProjectContext.Provider
      value={{ projects, current, currentId, selectProject, fetchProjects, loading }}
    >
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error("useProject must be used within ProjectProvider");
  return ctx;
}
